<template>
    <div class="login__form">
        <template v-for="(item, index) in formItem" :key="index">
            <InputCommon
                :inputItem="item"
                nameFunction="on-change-value-login"
            />
        </template>
    </div>
</template>
<script>
import InputCommon from "@/components/common/input/input.vue";
import languageMixins from "@/mixins/language-mixins";
export default {
    mixins: [languageMixins],
    components: { InputCommon },
    data() {
        return {
            formItem: [
                {
                    label: "terminal",
                    name: "terminal",
                    type: "text",
                    required: true,
                },
                {
                    label: "terminal pin",
                    name: "terminalPin",
                    type: "password",
                    required: true,
                },
            ],
        };
    },
    methods: {},
};
</script>
